import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

import "@splidejs/react-splide/css";
import "./animation/dotBlink.css";

const WebsiteStatusCarousel = ({ data }) => {
  if (!data || !data.length) return null;

  return (
    <div className="card">
      <div className="card-body p-2">
        <Splide
          options={{
            type: "loop",
            drag: "free",
            focus: "center",
            perPage: 3,
            gap: "1rem",
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: 1,
            },
          }}
          extensions={{ AutoScroll }}
        >
          {data.map((site, index) => (
            <SplideSlide key={index}>
              <div
                className="d-flex align-items-center  fw-bold"
                style={{
                  fontSize: "1.5rem",
                    whiteSpace: "nowrap",
                }}
              >
                {/* Blinking dot */}
                <span 
                  className={`status-dot ${
                    site.status === "UP" ? "bg-green" : "bg-red"
                  }`}
                ></span>

                {/* Website name */}
                <span className="ms-2">{site.name}</span>
              </div>
            </SplideSlide>
          ))}
        </Splide>
      </div>
    </div>
  );
};

export default WebsiteStatusCarousel;
